import { slugify } from "../../../Boilerplate/_Shared/slugify";
import {
  prefix,
  getAuthHeaders,
  jsonDelete,
  jsonGet,
  jsonPost,
  jsonPut,
} from "../api";

export async function getContentItems(
  brandId,
  page,
  pageSize,
  status,
  language,
  q,
  sourceOnly
) {
  var params = new URLSearchParams();
  if (brandId) params.append("brandId", brandId);
  if (page) params.append("page", page);
  if (pageSize) params.append("pageSize", pageSize);
  if (status) params.append("status", status);
  if (language) params.append("language", language);
  if (q) params.append("q", q);
  if (sourceOnly != null) params.append("sourceOnly", sourceOnly);
  return await jsonGet(`content/items?${params.toString()}`);
}

export const getContentItem = async (id) =>
  await jsonGet(`content/items/${id}`);
export const createContentItem = async (dto) =>
  await jsonPost(`content/items`, dto);
export const updateContentItem = async (id, dto) =>
  await jsonPut(`content/items/${id}`, dto);
export const deleteContentItem = async (id) =>
  await jsonDelete(`content/items/${id}`);

export const getContentCategories = async (brandId) => {
  var params = new URLSearchParams();
  if (brandId) params.append("brandId", brandId);
  return await jsonGet(`content/categories?${params.toString()}`);
};
export const updateContentCategory = async (id, dto) =>
  await jsonPut(`content/categories/${id}`, dto);
export const createContentCategory = async (dto) =>
  await jsonPost(`content/categories`, dto);
export const deleteContentCategory = async (id) =>
  await jsonDelete(`content/categories/${id}`);

export const createContentIdeas = async (dto) =>
  await jsonPost(`content/ideas`, dto);

export const getContentIdeaBatches = async (page, pageSize) => {
  var params = new URLSearchParams();
  if (page) params.append("page", page);
  if (pageSize) params.append("pageSize", pageSize);
  return await jsonGet(`content/ideas/batches?${params.toString()}`);
};

export const getContentIdeaBatch = async (batchId) =>
  await jsonGet(`content/ideas/${batchId}`);

export const discardContentIdea = async (ideaId) =>
  await jsonDelete(`content/ideas/${ideaId}`);

export const convertIdeaToContent = async (ideaId, categoryId) =>
  await jsonPost(`content/ideas/${ideaId}/convert`, { categoryId });

export const generateFromBrief = async (contentItemId) =>
  await jsonPost(`content/items/${contentItemId}/generate-from-brief`);

export const generateContentImages = async (contentItemId, model, imageCount) =>
  await jsonPost(`content/items/${contentItemId}/image-generation-jobs`, { model, imageCount });

export const translateContentItem = async (id, languages) =>
  await jsonPost(`content/items/${id}/translation-jobs`, { languages });

export const getTranslationSiblings = async (id) =>
  await jsonGet(`content/items/${id}/translations`);

export const bulkTranslateContentItems = async (contentItemIds, languages) =>
  await jsonPost(`content/items/bulk-translation-jobs`, { contentItemIds, languages });

export const approveAutopilot = async (id) =>
  await jsonPost(`content/items/${id}/approve-autopilot`);

export const reviewContentItem = async (id) =>
  await jsonPost(`content/items/${id}/review`);

export const publishContentItem = async (id) =>
  await jsonPost(`content/items/${id}/publish`);

export const generateFreeFormImage = async (brandId, prompt, model, aspectRatio, containsText = false, transparent = false) =>
  await jsonPost(`content/assets/generate`, { brandId, prompt, model, aspectRatio: aspectRatio || undefined, containsText, transparent });

export async function getContentAssets(brandId, page, pageSize) {
  var params = new URLSearchParams();
  if (brandId) params.append("brandId", brandId);
  if (page) params.append("page", page);
  if (pageSize) params.append("pageSize", pageSize);
  return await jsonGet(`content/assets?${params.toString()}`);
}

export const deleteContentAsset = async (id) =>
  await jsonDelete(`content/assets/${id}`);

export const getAssetByUrl = (filePath) =>
  jsonGet(`content/assets/by-url?filePath=${encodeURIComponent(filePath)}`);

export const regenerateTranslatedImage = (assetId, targetLanguage, contentItemId) =>
  jsonPost(`content/assets/${assetId}/regenerate-translated`, { targetLanguage, contentItemId });

export const regenerateImage = (assetId, contentItemId) =>
  jsonPost(`content/assets/${assetId}/regenerate`, { contentItemId });

export const auditContentLinks = async (contentItemId) =>
  await jsonGet(`content/items/${contentItemId}/link-audit`);

export const removeContentLink = async (contentItemId, url, blockDomain = false) =>
  await jsonPost(`content/items/${contentItemId}/remove-link`, { url, blockDomain });

export async function uploadContentImage(file, brandId) {
  let authHeaders = getAuthHeaders();
  var response = await fetch(`${prefix}/content/assets?brandId=${brandId}`, {
    method: "POST",
    body: file,
    headers: {
      ...authHeaders,
      "content-type": file.type,
      "content-disposition": `attachment; filename=${slugify(
        file.name
      )}; filename*=UTF-8''${encodeURI(file.name)}`,
      "content-length": `${file.size}`,
    },
  });
  return await response.json();
}
